import { render, staticRenderFns } from "./LbaValueOrder.vue?vue&type=template&id=36b18c5f&scoped=true"
import script from "./LbaValueOrder.vue?vue&type=script&lang=js"
export * from "./LbaValueOrder.vue?vue&type=script&lang=js"
import style0 from "./LbaValueOrder.vue?vue&type=style&index=0&id=36b18c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b18c5f",
  null
  
)

export default component.exports